<template lang='pug'>
  include ./../../mixins
  +b.DIV
    +b.mdi.mdi-close.fs_xl.color_green.close-modal--common(@click.prevent="toggleHandler")
  
    +b.text_center.color_green.fs_md.fs_3lg.layout_top_md.margin_bottom_lg.P(v-if="title") {{title}}
    +b.text_center.color_darkgray.fs_md.fs_2md.P {{ text }}
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: false
      },
      text: {
        type: String,
        required: false
      }
    },
    methods: {
      toggleHandler() {
        this.$modal.hide("success")
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/SuccessModal.vue